import { enumLabelsToOptions } from "../../libs/utils/enums";

export const RANGE_OF_EMPLOYEES = {
    FROM_1_20: "FROM_1_20",
    FROM_21_50: "FROM_21_50",
    FROM_51_100: "FROM_51_100",
    FROM_101_200: "FROM_101_200",
};

export const RANGE_OF_EMPLOYEES_LABELS = {
    [RANGE_OF_EMPLOYEES.FROM_1_20]: "De 1 a 20",
    [RANGE_OF_EMPLOYEES.FROM_21_50]: "De 21 a 50",
    [RANGE_OF_EMPLOYEES.FROM_51_100]: "De 51 a 100",
    [RANGE_OF_EMPLOYEES.FROM_101_200]: "De 101 a 200",
};

export const RANGE_OF_EMPLOYEES_AS_OPTIONS = enumLabelsToOptions(
    RANGE_OF_EMPLOYEES_LABELS
);
